import { CommonModule, TitleCasePipe, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  LOCALE_ID,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { I18nService } from '../../services/i18n.service';
import { SUPPORTED_LANGUAGES } from 'src/app/app.config';
import { MenuComponent } from '../menu/menu.component';
import { filter } from 'rxjs';
import { ReplaceMinusWithUnderscorePipe } from '../../pipes/replace-minus-with-underscore.pipe';

@Component({
  selector: 'app-nav',
  standalone: true,
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [
    CommonModule,
    InlineSVGModule,
    TranslateModule,
    RouterModule,
    MenuComponent,
    UpperCasePipe,
    TitleCasePipe,
    ReplaceMinusWithUnderscorePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent implements OnInit {
  protected readonly locale = inject(LOCALE_ID);
  protected readonly i18nService = inject(I18nService);

  protected nextLanguage?: string;
  public floating = false;
  public menuOpen = false;

  protected searchOpen = false;
  currentRoute = '';

  private readonly router = inject(Router);

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.floating = window.scrollY > 150;
  }

  ngOnInit(): void {
    this.getNextLanguage();

    this.setPageTitle();
  }

  getNextLanguage() {
    const currentLanguage = this.i18nService.getLanguage();
    const currentLanguageIndex = SUPPORTED_LANGUAGES.indexOf(currentLanguage);
    const nextLanguageIndex =
      (currentLanguageIndex + 1) % SUPPORTED_LANGUAGES.length;
    this.nextLanguage = SUPPORTED_LANGUAGES[nextLanguageIndex];
    return nextLanguageIndex;
  }

  switchLanguage(): void {
    const nextLanguageIndex = this.getNextLanguage();
    this.i18nService.setLanguageAndReload(
      SUPPORTED_LANGUAGES[nextLanguageIndex],
    );
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  protected toggleSearch(): void {
    this.searchOpen = !this.searchOpen;
  }

  setPageTitle(): void {
    this.currentRoute = this.router.url.split('#')[0].split('/')[1] || 'home';

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe(() => {
        this.currentRoute =
          this.router.url.split('#')[0].split('/')[1] || 'home';
      });
  }
}
